import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import development from './env.development';
import production from './env.production';
import test from './env.test';
import realpre from './env.realpre';
var envConfig = {
  development: development,
  production: production,
  test: test,
  realpre: realpre
}[process.env.VUE_APP_ENV];
export default _objectSpread(_objectSpread({}, envConfig), {}, {
  appId: 'wxeb44cbdd549b2fb1',
  // 微信订阅号ID
  serviceAppId: 'wx9afbdd727cb19b21' // 微信服务号ID
});